import { Box, styled } from "@mui/material";
import { blue } from "@mui/material/colors";

const MessageBox = styled(Box)({
  fontSize: "21px",
  paddingBottom: "20px",
  lineHeight: "1.3",
});

export const prepareComment = (text: string) => {
  const comment = text
    .replace(/=A=:/g, "|=A=:")
    .replace(/\[C\]:/g, "|[C]:")
    .replace(/\(B\):/g, "|(B):")
    .replace(/\[U\]:/g, "|[U]:")
    .split("|");

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const chat: any[] = [];
  comment.forEach((part) => {
    let actor = "";
    if (part.match(/\[C\]:/)) {
      actor = "customer";
    } else if (part.match(/\(B\):/)) {
      actor = "bot";
    } else if (part.match(/\[U\]:/)) {
      actor = "unknown";
    }

    const text = part.replace(/(?:\r\n|\r|\n|¬)/g, "\n");

    if (!text) {
      return;
    }
    chat.push(
      <MessageBox
        key={"msg" + chat.length}
        className={`msg ${actor}`}
        color={actor === "customer" ? blue[700] : ""}
        fontWeight={actor === "customer" ? 600 : 400}
      >
        {text}
      </MessageBox>
    );
  });

  return chat;
};
